// Messages for portal/MagicLinkRequest (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.magic_link.head': 'Email sign-in link — Customer portal',
  'portal.magic_link.title': 'Email me a sign-in link',
  'portal.magic_link.sent':
    'If that email has access, a single-use sign-in link is on its way. It expires in 15 minutes.',
  'portal.magic_link.email': 'Email',
  'portal.magic_link.submit': 'Send link',
}

export const zhTW = {
  'portal.magic_link.head': '寄送登入連結 — 客戶入口',
  'portal.magic_link.title': '寄送登入連結給我',
  'portal.magic_link.sent':
    '若該電子郵件具有存取權限，一次性登入連結即將寄出。連結將於 15 分鐘後失效。',
  'portal.magic_link.email': '電子郵件',
  'portal.magic_link.submit': '寄送連結',
}
